module.exports = __webpack_public_path__ + "img/mfmd.d9246f90.jpg";